<template>
	<div class="aboutus-page header--padding" v-if="news">
	<div class="main_page_banner">
		<banner class="documents__banner header--additive-padding aboutus-banner" :backgrounds="bannerBackgroundImage">
		</banner>
	</div>
		<div class="aboutus-page__body panel">
			
			<div
				v-for="(item, index) in news.content"
				:key="index"
				class="aboutus-page__module"
				:class="[
					index === 0 ? 'aboutus-page__module--first' : '',
					'aboutus-page__module--' + item.type
				]"
			>
				<div
					class="aboutus-page__centraliser text-center"
					:class="{
						'aboutus-page__centraliser--wide':
							item.type === 'video' && index === 0,
						'aboutus-page__centraliser--medium ':
							item.type === 'video' && index !== 0 ||
							item.type === 'game' ||
							item.type === 'image' ||
							item.type === 'blockquote' ||
							item.type === 'download'
					}"
				>

					<!-- TEXT -->
					<div
						v-if="item.type === 'text'"
						v-html="sanitizeText(item.content)"
						class="about-us-text"
					/>

					<!-- GAME -->
					<div
						v-if="item.type === 'game'"
						class="grid"
					>
						<router-link
							v-for="(gameId, i) in item.games"
							:key="i"
							:to="{ name: 'Games', params: { activeGameId: gameId } }"
							class="grid__item one-half"
						>
							<game-overview :game="getGame(gameId)"/>
						</router-link>
					</div>

					<!-- IMAGE -->
					<img
						v-else-if="item.type === 'image' && item.image && item.image.link"
						:src="item.image.link"
						:alt="item.image.metadata"
					/>

					<!-- VIDEO -->
					<div
						v-else-if="item.type === 'video'"
						class="wistia_responsive_padding"
						style="padding: 56.25% 0 0 0; position: relative;"
					>
						<div
							class="wistia_responsive_wrapper"
							style="height: 100%; left: 0; position: absolute; top: 0; width: 100%;"
						>
							<div
								:class="'seo=false videoFoam=true autoPlay=false wistia_embed wistia_async_' + getVideoId(item)"
								style="height: 100%; width: 100%;"
							/>
						</div>
					</div>

					<!-- BLOCKQUOTE -->
					<div
						v-else-if="item.type === 'blockquote'"
						v-html="item.blockquote"
					/>

					<!-- BUTTON / LINK -->
					<btn
						v-else-if="item.type === 'link'"
						:link="item.link"
						:class="btn_more"
					>
						<span v-html="item.title" />
					</btn>

					<!-- DOWNLOAD -->
					<div
						v-else-if="item.type === 'download' && item.download"
						class="aboutus-page__download"
					>
						<div
							class="aboutus-page__download__image"
							:style="`background-image:url('${getAssetImage(item.download)}')`"
						/>
						<div class="aboutus-page__download__meta">
							<h2
								v-if="item.title"
								class="aboutus-page__download__title"
							>{{ item.title }}</h2>
							<p
								v-if="item.description"
								class="aboutus-page__download__description"
							>{{ item.description }}</p>
							<router-link
								:to="getAssetLink(item.download)"
								class="link--action link--arrow link--colored"
							>
								Download Asset Pack
							</router-link>
						</div>

					</div>


					<!-- IMAGEWITHTEXT -->
	
					<div v-else-if="item.type === 'imagewithtext'" class="image_text_block" :style="`background:${item.backgroundColor}`">
						<div class="page-container">
							<div class="grid block_grid">
								<div v-if="item.alignment === 'left'" class="grid__item one-half">
									<div class="block_image">
										<img
											v-if="item.image && item.image.link"
											:src="item.image.link"
											:alt="item.image.metadata"
										/>
									</div>
								</div>
								<div class="grid__item one-half">
									<div class="block_text" :style="`color:${item.fontColor}`">
										<div
											v-html="sanitizeText(item.description)"
										/>
										<a v-if="item.ctaTitle != ''" :href="`${item.ctaLink}`" class="btn btn--shape--h48" :style="`color:${item.fontColor}; margin-top: 40px; border: 1px solid ${item.fontColor}`">{{ item.ctaTitle }}</a>
									</div>
								</div>
								<div v-if="item.alignment === 'right'" class="grid__item one-half">
									<div class="block_image">
										<img
											v-if="item.image && item.image.link"
											:src="item.image.link"
											:alt="item.image.metadata"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>


					

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { filter, sortBy } from 'lodash'
import Btn from './atoms/Btn'
import Banner from './molecules/Banner'
import NewsOverview from './molecules/NewsOverview'
import GameOverview from './molecules/GameOverview'

export default {
	name: 'AboutUs',
	components: {
		Btn,
		Banner,
		NewsOverview,
		GameOverview
	},
	data () {
		return {
			news: null,
			allNews: [],
			category: null,
			bannerBackgroundImage: {}
		}
	},
	computed: {
		postUrl () {
			return document.URL
		}
	},
	async created () {
		this.getNewsPost()
	},
	watch: {
		news () {
			var self = this

			self.news.content.map(obj => {
				if (obj.type === 'video') {
					let videoId;
					if(this.isStringOfTypeUrl(obj.video)) {
						videoId =  obj.video.substring(obj.video.lastIndexOf('/') + 1)
					} else {
						videoId = obj.video
					}

					let scriptOne = document.createElement('script')
					scriptOne.setAttribute('src', '//fast.wistia.com/embed/medias/' + videoId + '.jsonp')
					document.head.appendChild(scriptOne)

					let scriptTwo = document.createElement('script')
					scriptTwo.setAttribute('src', '//fast.wistia.com/assets/external/E-v1.js')
					document.head.appendChild(scriptTwo)
				}
			})

		},
		'$root.userSelectedRegionKey': function () {
			this.$root.appImmediateLoading = true

			this.getNewsPosts()
				.then(() => {
					this.$root.appImmediateLoading = false
				})
		},
		'$route.params.id': function () {
			this.getNewsPost(this.$route.params.id)
		}
	},
	methods: {
		async getNewsPost (id) {
			const self = this

			// Get specific news posts
			return self.$api.getAboutUspage().then((data) => {
				if (data.hasOwnProperty('data')) {
					this.groupGames(data.data.results.content)
					self.news = data.data.results
					this.heroData(data.data.results);
				}
				self.$root.$data.appLoading = false
			}).catch((error) => {
				self.$alert.danger({ message: error.message })
			})
		},
		heroData(data) {
			var self = this;

			self.bannerBackgroundImage = {
				mob: data.imageLarge.link,
				ptab: data.imageLarge.link,
				ltab: data.imageHero.link,
				desk: data.imageHero.link,
			};
		},
		getNewsPosts () {
			var self = this

			// Get all news posts
			var regions = this.$root.userSelectedRegion ? [this.$root.userSelectedRegion.key] : null
			return self.$api.getNews(null, null, null, null, null, regions).then((data) => {
				if (data.hasOwnProperty('data')) {
					self.allNews = data.data.results
				}
				self.$root.$data.appLoading = false
			}).catch((error) => {
				self.$alert.danger({ message: error.message })
			})
		},
		getCategory (id) {
			const self = this
			self.$api.getCategory(id).then((response) => {
				self.category = response.data
			}).catch((error) => {
				self.$alert.danger({ message: error.message })
			})
		},
		getGame (id) {
			const self = this
			if (!self.$root.$data.games) return null
			return self.$root.$data.games.find(game => game.id === parseInt(id))
		},
		groupGames (content) {
			try {
				// Clone the content array
				let items = [...content]

				// Create an offset so can sync the indexes between items[] and content[]
				let offset = 0

				// Loop through all blocks and group game type objects together
				items.forEach((item, i) => {

					// Skip if type is not "game"
					if (item.type !== 'game') return

					// Skip if previous item is of type "game"
					if (items[i - 1] !== undefined && items[i - 1].type === 'game') return

					// Add current item's game ID to games[]
					let games = []
					games.push(item.game)

					// Look ahead and push game IDs to games[]
					let counter = i + 1
					if (items[counter] !== undefined && items[counter].type === 'game') {
						let lookahead = true
						while (lookahead === true) {

							// Check if next item exists and is a game
							if (items[counter] !== undefined && items[counter].type !== 'game') {
								lookahead = false
								break
							}

							// Add to games[] and remove block from content[]
							games.push(items[counter].game)
							content.splice(counter - offset, 1)

							// Increment counters
							counter++
							offset++
						}
					}

					// Remove old game attribute and add games[]
					const targetIndex = counter - 1 - offset
					delete content[targetIndex].game
					content[targetIndex].games = games
				})
			} catch (e) {
				console.error(e)
			}
		},
		getAssetLink (download) {
			const { path, id } = JSON.parse(download)
			return `/${path || 'asset-manager'}/${id}`
		},
		getAssetImage (download) {
			const { iconOverride } = JSON.parse(download)
			return iconOverride || '/static/img/fallback-asset.jpg'
		},
		sanitizeText (string) {
			if (!string) return
			return string.replace(/style="(.*?)"/, '')
		},
		getVideoId(item) {
			const self = this
			if(self.isStringOfTypeUrl(item.video)) {
				return item.video.substring(item.video.lastIndexOf('/') + 1)
			} else {
				return item.video
			}
		},
		isStringOfTypeUrl(str) {
			var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
				'(\\#[-a-z\\d_]*)?$','i'); // fragment locator
			if(pattern.test(str)) {
				return true;
			} else {
				return false;
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "src/scss/toolkit";

$c: ".aboutus-page";
#{$c} {
	&__centraliser {
		@include extend(page-container);
		//max-width: 584px + (2 * $page-padding);
		max-width: 100%;
		padding: 0;

		&--medium {
			max-width: 792px + (2 * $page-padding);
		}

		&--wide {
			max-width: 1000px + (2 * $page-padding);
		}
	}

	&__header {
		text-align: center;
		padding-bottom: rem(64);
	}

	&__category {
		display: inline-block;
		@include extend(h6);
		color: palette('link');
		margin-bottom: rem(24);
	}

	&__title {
		@include extend(h1);
		font-size: rem(56);
		line-height: 1.14em;
		margin-bottom: rem(48);
	}

	&__meta {
		margin-bottom: rem(16);
	}

	&__date {
		display: inline-block;
		font-size: rem(14);
		color: palette(light-grey);
	}

	&__hero-wrap,
	&__module--video#{$c}__module--first {
		text-align: center;
		margin-top: rem(-25);
		margin-bottom: rem(80);
		position: relative;
		z-index: 0;

		@include media(not-phab) {
			margin-top: rem(-64);
		}

		&:before {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 50%;
			background-color: palette('lightest-grey');
			z-index: -1;
		}
	}

	&__module {
		/*margin-bottom: rem(80);*/

		&--text {
			font-size: rem(20);
			line-height: (28/20);
			color: palette(grey);

			h1, h2, h3, h4, h5, h6 {
				color: palette(font);
				@include extend(heading--black);

				&:not(:first-child) {
					margin-top: 0.75em;
				}

				&:not(:last-child) {
					margin-bottom: 0.75em;
				}

				&:last-child {
					margin-bottom: rem(-8);
				}
			}

			h1, h2 {
				@include extend(h3-size);
			}

			h3 {
				@include extend(h4-size);
			}

			h4 {
				@include extend(h5-size);
			}

			h5, h6 {
				@include extend(h6-size);
			}

			a {
				color: palette('link');
				font-weight: bold;
			}
		}

		&--image,
		&--video,
		&--link {
			text-align: center;
		}

		&--blockquote {
			text-align: center;
			@include extend(h2);

			&:not(:first-child) {
				margin-top: rem(72);
			}
		}

		&--game .grid {
			justify-content: center;
		}
	}

	&__download {
		border: 1px solid palette('divider');
		display: flex;
		align-items: stretch;

		&__image {
			flex: 0 0 33%;
			background-position: 50% 50%;
			background-size: cover;
		}

		&__meta {
			flex: 1 0 67%;
			padding: rem(40);
			color: palette('grey');
			letter-spacing: 0;
		}

		&__title {
			font-size: 24px;
			color: palette('black');
			letter-spacing: 0;
			line-height: 32px;
		}
	}

	&__game {

		&__image-wrapper {
			position: relative;
			overflow: hidden;
			display: block;
			text-align: center;

			> *, &:before {
				display: inline-block;
				vertical-align: middle;
			}

			&:before {
				position: relative;
				z-index: 1;
				content: "";
				width: 100%;
				padding-top: 100% * (217/300);
			}
		}

		&__image {
			position: absolute;
			top: 50%;
			left: 50%;
			min-width: 100%;
			min-height: 100%;
			transform: translateX(-50%) translateY(-50%);
		}
	}

	&__share {
		text-align: center;
		margin-top: rem(88);

		&-btn {
			padding-left: rem(20);
			padding-right: rem(24);
			color: palette('white');

			&--facebook {
				background-color: #4460A0;
			}

			&--twitter {
				background-color: #00AAEC;
			}

			&--linked-in {
				background-color: #007EBB;
			}
		}

		&-icon {
			font-size: rem(20);
		}
	}
}
.aboutus-page__body.panel {
	padding-top: 0;
	padding-bottom: 0;
}
.image_text_block{
	/*background: #E57B37;*/
	padding: 30px 0px;
}
.image_text_block .page-container{
    max-width: 80rem;
}
.block_grid{
	align-items: center;
}
.image_text_block .block_image img{
	width: 100%;
	border-radius: 8px;
	box-shadow: 0px 10px 10px rgba(0,0,0,0.5);
}
.block_text{
	font-family: Lato, sans-serif !important;
    font-style: normal;
	text-align: left;
}
.aboutus-page__module--text {
	font-family: Lato, sans-serif;
    font-style: normal;
}
.block_text h1{
	font-size: 2rem;
    line-height: 2.5rem;
	font-weight: 500;
	font-family: Lato,sans-serif;
    font-style: normal;
	color: #fff;
}
.block_text p{
	font-size: 1rem;
    line-height: 1.5rem;
	font-weight: 300;
    color: #fff;
}
.btn_more{
	background: transparent!important;
    border: 1px solid #fff;
	border-radius: 8px;
	padding: 5px 20px!important;
	text-decoration: none;
	text-transform: capitalize;
	margin-top: 30px;
	font-weight: 200!important;
}
.btn_dark {
	border: 2px solid #000 !important;
	color: #000 !important;
}
.btn_more:hover{
	background: transparent!important;
}
.documents__banner.banner {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
	min-height: 400px;
}

.aboutus-page{
	padding-top: 0;
	position: relative;
}
.main_page_banner{
	position: relative;
}
.aboutus-page__header{
	position: absolute;
	left: 50%;
	top: 70%;
	transform: translate(-50%, -30%);
	padding: 0;
	background: transparent;
}
.aboutus-page__title{
	margin-bottom: 0;
	background: rgba(0,0,0,0.9);
	color: #fff;
	border-radius: 20px;
	padding: 14px 24px;
	font-weight: 700;
	font-size: 48px;
}
.aboutus-page_content{
    border: 6px solid rgba(0,0,0,0.4);
	border-radius: 24px;
}
.text-center{
	text-align: center;
}
.about-us-text {
	max-width: 80%;
	margin: auto;
	padding: 30px 0;
}
.aboutus-page__module--image > .aboutus-page__centraliser--medium{
	max-width: 80%;
}
.aboutus-page__centraliser--medium img {
	width: 100%;
}
.aboutus-banner {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: top center;
}
.aboutus-page__module--link {
	/*margin-bottom: 1rem;*/
	padding: 30px 0;
}
@media(max-width: 767px){
	.one-half {
    width: 100%;
}
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue